import { KYMW4701Model } from '../kymw4701.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * マルチ商品情報削除
 *
 * @export API通信成功時の処理
 * @class DeleteMultiGoodsService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class DeleteMultiGoodsService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW4701Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteMultiGoodsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MultiCode: this.model.multiCode,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4701Model} model
   * @param {Function} [successFunc] 成功時後続処理
   * @memberof DeleteMultiGoodsService
   */
  execute(
    model: KYMW4701Model,
    successFunc: Function = null,
    exceptionErrorFunc: Function = null
  ) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('deleteMultiGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteMultiGoodsService
   */
  success(data: any) {
    if (this.successFunc) this.successFunc();
  }
}
